import { twMerge } from "tailwind-merge";
import { useState } from "react";
import { useSelector } from "src/redux";
import { useWidgetDndContextData } from "src/context/WidgetDndContext";
const RenderViewMoreAndLess = (props) => {
  const ITEM_LIMIT = props?.isLayout2 ? 10 : 5;
  const [numOfItemToShow, setNumOfItemToShow] = useState(ITEM_LIMIT)
  const { data, childComponent, customClass } = props
  const storeInfo = useSelector((state) => state.storeReducer.store);
  const {
    widgetContextState: { isBuilder, globalStyle },
  } = useWidgetDndContextData();
  const themeColor = isBuilder ? globalStyle?.color?.themeColor : storeInfo?.theme?.colors?.primary_color;
  
  return (
    <div className="tw-flex tw-flex-col tw-gap-[16px]">
      <div className={twMerge(customClass)}>
        {
          data?.slice(0, numOfItemToShow)?.map((item, index) => {
            return (
              <div key={index}>
                {childComponent(item)}
              </div>
            )
          })
        }
      </div>
      {
        numOfItemToShow < data?.length &&
        <div style={{ color: themeColor || '#000000' }} className="tw-text-[14px] tw-font-normal  tw-cursor-pointer" onClick={() => setNumOfItemToShow(data?.length)}>{`+ ${data?.length - ITEM_LIMIT}`} More</div>
      }
      {
        numOfItemToShow > ITEM_LIMIT &&
        <div style={{ color: themeColor || '#000000' }} className='tw-text-[14px] tw-font-normal tw-cursor-pointer' onClick={() => setNumOfItemToShow(ITEM_LIMIT)}>View Less</div>
      }
    </div>
  )
}

export default RenderViewMoreAndLess